
// Import services directly from their implementation files
import { 
  getPublishedPosts, 
  getPostBySlug, 
  getAllPosts, 
  getPostById, 
  uploadImage
} from './services/postService';

import {
  createPost,
  updatePost,
  deletePost,
  duplicatePost
} from './services/postManagementService';

// Export the BlogService as the main interface
export const BlogService = {
  // Fetching posts
  getPublishedPosts,
  getPostBySlug,
  getAllPosts,
  getPostById,
  
  // Managing posts
  createPost,
  updatePost,
  deletePost,
  duplicatePost,
  
  // Image handling
  uploadImage
};

// Also export these functions directly for convenience
export { 
  getPublishedPosts, 
  getPostBySlug, 
  getAllPosts, 
  getPostById, 
  createPost,
  updatePost,
  deletePost,
  duplicatePost,
  uploadImage
};
